import React, { useEffect, useState } from "react";
import { connect } from 'react-redux'
import { getArticleHomeList, getArticleHomeListReset } from '../../action/getArticleHomeListAction'
import { Link } from 'react-router-dom';
import { Button, Col, Row } from "antd";
import { s3_cdn } from "../../utils";

function ArticleBlock(props) {

    const { getArticleHomeList, getArticleHomeListReset, getArticleHomeListState } = props
    const [articleData, setArticleData] = useState({
        "text": [],
        "audio": [],
        "video": [],
        "textAvailable": false,
        "audioAvailable": false,
        "videoAvailable": false
    })
    let Type = props.type
    // console.log(props)

    let paramsAL = {
        "week": 18,//props.week
        // "type": props.type 
    }

    useEffect(() => {
        getArticleHomeList(paramsAL);
        return () => {
            getArticleHomeListReset()
        }
    }, [])

    useEffect(() => {
        if (getArticleHomeListState.apiState === "success") {
            // console.log("real",getArticleHomeListState.data) 
            setArticleData({
                ['text']: getArticleHomeListState.text_articles,
                ['audio']: getArticleHomeListState.audio_articles,
                ['video']: getArticleHomeListState.video_articles,
                ['textAvailable']: true,
                ['audioAvailable']: true,
                ['videoAvailable']: true,
            })
        }
    }, [getArticleHomeListState])

    return (
        <div>
            <div className="curatedWrap">
                <Row className="row" gutter={24}>
                    <Col span={12} >
                        <Row className="row">
                            <Col className="col-sm-12 text-right" span={24} >
                                <img className="img-fluid curatedImg" src={articleData.textAvailable ? `${s3_cdn()}article/${articleData.text[0].image_path}` : `./images/mom1.svg`} alt="no" />
                                <div className="containerLeftPara">
                                    {articleData.textAvailable ? articleData.text[0].title : "Guide shows you how to take care of your Baby"}
                                </div>
                            </Col>
                        </Row>
                        <Row className="row" style={{ marginTop: '-60px' }}>
                            <Col className="col-sm-12 text-left" span={24}>
                                <img className="img-fluid curatedImg" src={articleData.textAvailable ? `${s3_cdn()}article/${articleData.text[1].image_path}` : `./images/rect2.svg`} alt="no" />
                                <div className="containerRightPara">
                                    {articleData.textAvailable ? articleData.text[1].title : "Guide shows you how to take care of your Baby"}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="col-sm-5" span={10}>
                        <h1 className="curatedTitle">Curated for you</h1>
                        <p className="homeCuratedPara mb-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit. At purus ut egestas phasellus enim aliquam ultrices urna. Donec molestie massa vitae sapien neque viverra et quis turpis. Imperdiet vestibulum proin morbi pellentesque ipsum urna eu lobortis adipiscing.</p>
                        <Button type="primary" shape="round">View More</Button>
                    </Col>
                </Row>
            </div>
            <div className="curatedWrap">
                <Row className="row" gutter={24}>
                    <Col span={12} >
                        <Row className="row">
                            <Col className="col-sm-12 text-right" span={24} >
                                <img className="img-fluid curatedImg" src={articleData.audioAvailable ? `${s3_cdn()}article/${articleData.audio[0].image_path}` : `./images/mom1.svg`} alt="no" />
                                <div className="containerLeftPara">
                                    {articleData.audioAvailable ? articleData.audio[0].title : "Guide shows you how to take care of your Baby"}
                                </div>
                            </Col>
                        </Row>
                        <Row className="row" style={{ marginTop: '-60px' }}>
                            <Col className="col-sm-12 text-left" span={24}>
                                <img className="img-fluid curatedImg" src={articleData.audioAvailable ? `${s3_cdn()}article/${articleData.audio[1].image_path}` : `./images/rect2.svg`} alt="no" />
                                <div className="containerRightPara">
                                    {articleData.audioAvailable ? articleData.audio[1].title : "Guide shows you how to take care of your Baby"}
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="col-sm-5" span={10}>
                        <h1 className="curatedTitle">Audios for the week</h1>
                        <p className="homeCuratedPara mb-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit. At purus ut egestas phasellus enim aliquam ultrices urna. Donec molestie massa vitae sapien neque viverra et quis turpis. Imperdiet vestibulum proin morbi pellentesque ipsum urna eu lobortis adipiscing.</p>
                        <Button type="primary" shape="round">View More</Button>
                    </Col>
                </Row>
            </div>
            <div className="homeVides">
                <Row className="row" gutter={24}>
                    <Col className="col-sm-5" span={10} offset={2}>
                        <h1 className="curatedTitle">Videos for the week</h1>
                        <p className="homeCuratedPara mb-5">Lorem ipsum dolor sit amet, consectetur adipiscing elit. At purus ut egestas phasellus enim aliquam ultrices urna. Donec molestie massa vitae sapien neque viverra et quis turpis. Imperdiet vestibulum proin morbi pellentesque ipsum urna eu lobortis adipiscing.</p>
                        <Button type="primary" shape="round">View More</Button>
                    </Col>
                    <Col span={12} >
                        <Row className="row">
                            <Col className="col-sm-12 text-left" span={24} >
                                <img className="img-fluid curatedImg" src={articleData.videoAvailable ? `${s3_cdn()}article/${articleData.video[0].image_path}` : `./images/rect3.svg`} alt="no" />
                                <div className="containerLeftPara homeVideoLeft">
                                    {articleData.videoAvailable ? articleData.video[0].title : "Guide shows you how to take care of your Baby"}
                                </div>
                            </Col>
                        </Row>
                        <Row className="row" style={{ marginTop: '-60px' }}>
                            <Col className="col-sm-12 text-right" span={24}>
                                <img className="img-fluid curatedImg" src={articleData.videoAvailable ? `${s3_cdn()}article/${articleData.video[1].image_path}` : `./images/rect4.svg`} alt="no" />
                                <div className="containerRightPara homeVideoRight">
                                    {articleData.videoAvailable ? articleData.video[1].title : "Guide shows you how to take care of your Baby"}
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({

    getArticleHomeListState: state.getArticleHomeList,

})

const mapDispatchToProps = (dispatch) => ({
    getArticleHomeList: (params) => dispatch(getArticleHomeList(params)),
    getArticleHomeListReset: () => dispatch(getArticleHomeListReset()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ArticleBlock) 